import { SideBarButton, SideBarData } from '../class/sidebar';
import { AdminitracionRoutes } from 'src/app/settings/routes/administracion/administracion-routes';
import { AreasdeTrabajoNavRoutes } from 'src/app/settings/routes/areas-de-trabajo/areas-de-trabajo-navroutes';
import { DepartamentosNavRoutes } from 'src/app/settings/routes/departamentos/departamentos-navroutes';
import { ReportesNavRoutes } from 'src/app/settings/routes/reportes/reportes-navroute';
import { ClientReportsRoutes } from 'src/app/settings/routes/other-routes/client-reports-routes';
import { SalesReportsRoutes } from 'src/app/settings/routes/other-routes/sales-reports-routes';
import { sidebarShipHawkData } from 'src/app/settings/routes/shipHawk/shipHawk-routes';

export const SidebarProductionData: SideBarButton[] = [
  AdminitracionRoutes,
  AreasdeTrabajoNavRoutes,
  DepartamentosNavRoutes,
  ReportesNavRoutes,
  ClientReportsRoutes,
  SalesReportsRoutes,
];

export const SidebarProduction: SideBarData = {
  name: 'S&B Filters',
  img: '/assets/img/logo.png',
  icon: '/assets/img/logo-black.png',
  data: SidebarProductionData,
};

export const sidebarShipHawk: SideBarData = {
  name: 'ShipHawk',
  img: '/assets/img/shiphawk-logo.jpg',
  icon: '/assets/img/shiphawk-logo.jpg',
  data: sidebarShipHawkData,
};
